module.exports = __webpack_public_path__ + "img/menu-icon-search-white.8730c1a1.svg";